/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-21 13:39:17
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-05-28 15:50:24
 */
import configData from "../config/config";
import mumeListData from "./menu";
import Home from "../views/home/home.vue";
// import ShareSettlement from "../views/revenue-settlement/share-settlement/share-settlement.vue";
// import ShareSettlementDetail from "../views/oper-manage/charge-order-list/components/charge-order-detail.vue";
// /revenue-settlement/share-detail/charge-order-detail
// import WithdrawForm from "../views/revenue-settlement/withdraw-form/withdraw-form.vue";
// import WithdrawFormAdd from "../views/revenue-settlement/withdraw-form/children/withdraw-form-add.vue";
// import WithdrawFormPreview from "../views/revenue-settlement/withdraw-form/children/cash-template.vue";
// import WithdrawFormEdit from "../views/revenue-settlement/withdraw-form/children/withdraw-form-add.vue";
import operationData from "../views/oper-manage/operation-data/operation-data.vue";
// import chargeOrderList from "../views/oper-manage/charge-order-list/charge-order-list.vue";
import pileInfo from "../views/pile-manage/pile-info/pile-info.vue";
import pileInfoDetail from "../views/pile-manage/pile-info/children/site-details/site-details.vue";
import pileList from "../views/pile-manage/pile-list/pile-list.vue";
// import pileListDetail from "../views/pile-manage/pile-list/children/edit-pile.vue";
//
// import siteMonitor from "../views/operation-analysis/site-monitor/site-monitor.vue";
// import alarmEvent from "../views/operation-analysis/alarm-event/alarm-event.vue";
// //
// import NonRealNameCardManagement from "../views/member-management/non-real-name-card-management/non-real-name-card-management.vue";
// import nonRealAddCard from "../views/member-management/non-real-name-card-management/children/non-real-add-card.vue";
// import nonRealRecharge from "../views/member-management/non-real-name-card-management/children/non-real-recharge.vue";
// import nonRealDelCard from "../views/member-management/non-real-name-card-management/children/non-real-del-card.vue";
// import nonRealEditCard from "../views/member-management/non-real-name-card-management/children/non-real-edit-card.vue";
// import nonRealNameCardDetail from "../views/member-management/non-real-name-card-management/children/non-real-detail.vue";
// import nonRealHistory from "../views/member-management/non-real-name-card-management/children/non-real-history.vue";
// import nonFundHistory from "../views/member-management/non-real-name-card-management/children/non-fund-history.vue";
// import nonRealRefund from "../views/member-management/non-real-name-card-management/children/non-real-refund.vue";
// import MerchantManagement from "../views/merchant-management/merchant-management/merchant-management.vue";
//
const allRouter = [
    {
        path: "/home",
        name: "主页",
        component: Home,
    },
    // {
    //   path: "/test",
    //   name: "主页2",
    //   component: Test
    // },
    // {
    //   path: "/revenue-settlement",
    //   name: "收入结算",
    //   component: RevenueSettlement
    // },
    {
        path: "/merchant-management/share-settlement",
        name: "分成结算",
        // component: ShareSettlement,
        component: () => import("@/views/merchant-management/share-settlement/share-settlement.vue"),
    },
    // {
    //   path: "/revenue-settlement/share-settlement/share-settlement-detail",
    //   name: "分成结算订单详情",
    //   component: ShareSettlementDetail,
    // },
    {
        path: "/merchant-management/withdraw-form",
        name: "提现单",
        component: () => import("@/views/merchant-management/withdraw-form/withdraw-form.vue"),
    },
    {
        path: "/oper-manage/operation-data",
        name: "运营数据",
        component: operationData,
    },
    // {
    //   path: "/oper-manage/charge-order-list",
    //   name: "充电订单",
    //   component: chargeOrderList,
    // },
    // {
    //   path: "/oper-manage/charge-order-list/charge-order-detail",
    //   name: "充电订单详情",
    //   component: () =>
    //     import(
    //       "@/views/oper-manage/charge-order-list/children/charge-order-detail/charge-order-detail.vue"
    //     ),
    // },
    // // /pile-manage/pile-info/edit-ele-pile
    // {
    //   path: "/oper-manage/charge-order-list/abnormal-order",
    //   name: "异常订单",
    //   component: () =>
    //     import(
    //       "@/views/oper-manage/charge-order-list/children/abnormal-order/abnormal-order.vue"
    //     ),
    // },
    {
        path: "/pile-manage/pile-info",
        name: "站点信息",
        component: pileInfo,
    },
    {
        path: "/pile-manage/pile-info/detail",
        name: "站点详情",
        component: pileInfoDetail,
    },
    {
        path: "/pile-manage/pile-list",
        name: "充电桩信息",
        component: pileList,
    },
    {
        path: "/pile-manage/pile-list/pile-detail",
        name: "充电桩详情",
        component: () => import("@/views/pile-manage/pile-list/children/pile-details/pile-details.vue"),
    },
    {
        path: "/pile-manage/pile-list/pile-updata",
        name: "充电桩修改",
        component: () => import("@/views/pile-manage/pile-list/children/pile-updata/pile-updata.vue"),
        meta: {
            nameKey: "pileUpdata",
            footerBg: true,
        },
    },
    {
        path: "/pile-manage/pile-list/pile-updata-record",
        name: "桩修改记录",
        component: () => import("@/views/pile-manage/pile-list/children/pile-updata-record/pile-updata-record.vue"),
        meta: {
            nameKey: "pileUpdataRecord",
        },
    },
    {
        path: "/pile-manage/site-monitor",
        name: "站点监控",
        component: () => import("@/views/pile-manage/site-monitor/site-monitor.vue"),
    },
    {
        path: "/pile-manage/site-monitor/details",
        name: "站点监控详情",
        component: () => import("@/views/pile-manage/site-monitor/children/site-monitor-details/site-monitor-details.vue"),
        meta: {
            nameKey: "siteMonitorDetails",
        },
    },
    // {
    //   path: "/operation-analysis/alarm-list",
    //   name: "告警管理",
    //   component: alarmList
    // },
    // {
    //   path: "/operation-analysis/alarm-list/detail",
    //   name: "告警管理详情",
    //   component: alarmDetail
    // },
    // {
    //   path: "/operation-analysis/alarm-event",
    //   name: "事件告警",
    //   component: alarmEvent,
    // },
    //
    {
        path: "/oper-manage/non-real-name-card-management",
        name: "非实名卡管理",
        // component: NonRealNameCardManagement,
        component: () => import("@/views/oper-manage/non-real-name-card-management/non-real-name-card-management.vue"),
    },
    {
        path: "/oper-manage/recharge-manage",
        name: "充值管理",
        component: () => import("@/views/oper-manage/recharge-manage/recharge-manage.vue"),
    },
    {
        path: "/oper-manage/recharge-manage/recharge-manage-details",
        name: "充值记录详情",
        component: () => import("@/views/oper-manage/recharge-manage/children/recharge-manage-details/recharge-manage-details.vue"),
    },
    {
        path: "/oper-manage/refund-manage",
        name: "退款管理",
        component: () => import("@/views/oper-manage/refund-manage/refund-manage.vue"),
    },
    {
        path: "/oper-manage/refund-manage/refund-manage-details",
        name: "退款记录详情",
        component: () => import("@/views/oper-manage/refund-manage/children/records-details/records-details.vue"),
    },
    {
        path: "/oper-manage/non-real-name-card-management/non-real-add-card",
        name: "开卡",
        // component: nonRealAddCard,
        component: () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-add-card/non-real-add-card.vue"),
    },
    {
        path: "/oper-manage/non-real-name-card-management/non-real-recharge",
        name: "充值",
        component: () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-recharge/non-real-recharge.vue"),
    },
    {
        path: "/oper-manage/non-real-name-card-management/non-real-edit-card",
        name: "编辑",
        // component: nonRealEditCard,
        component: () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-edit-card/non-real-edit-card.vue"),
    },
    {
        path: "/oper-manage/non-real-name-card-management/non-real-name-card-detail",
        name: "非实名卡详情",
        // component: nonRealNameCardDetail,
        component: () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-detail/non-real-detail.vue"),
    },
    {
        path: "/oper-manage/non-real-name-card-management/non-real-del-card",
        name: "注销",
        // component: nonRealDelCard,
        component: () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-del-card/non-real-del-card.vue"),
    },
    {
        path: "/oper-manage/non-real-name-card-management/non-real-history",
        name: "操作记录",
        // component: nonRealHistory,
        component: () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-history/non-real-history.vue"),
    },
    {
        path: "/oper-manage/non-real-name-card-management/non-fund-history",
        name: "资金记录",
        // component: nonFundHistory,
        component: () => import("@/views/oper-manage/non-real-name-card-management/children/non-fund-history/non-fund-history.vue"),
    },
    {
        path: "/oper-manage/non-real-name-card-management/non-real-refund",
        name: "退款",
        // component: nonRealRefund,
        component: () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-refund/non-real-refund.vue"),
    },
    {
        path: "/merchant-management/merchant-management",
        name: "商户信息",
        component: () => import("@/views/merchant-management/merchant-management/merchant-management.vue"),
    },
    // {
    //   path: "/oper-manage/off-card-order",
    //   name: "离线卡订单",
    //   component: () =>
    //     import("@/views/oper-manage/off-card-order-list/off-card-order-list.vue"),
    // },
    // {
    //   path: "/oper-manage/off-card-order/charge-order-detail",
    //   name: "离线卡订单详情",
    //   component: () =>
    //     import(
    //       "@/views/oper-manage/off-card-order-list/children/off-order-detail.vue"
    //     ),
    //   meta: {
    //     nameKey: "offCardOrderDetails",
    //   },
    // },
    {
        path: "/merchant-management/authority",
        name: "权限管理",
        component: () => import("@/views/merchant-management/access-configuration/access-configuration.vue"),
    },
    // {
    //   path: "/system-manage/auth/add-role",
    //   name: "新增角色",
    //   component: () =>
    //     import(
    //       "@/views/sys-manage/access-configuration/children/add-role-info/add-role-info.vue"
    //     ),
    //   meta: {
    //     nameKey: "addRoleInfo",
    //   },
    // },
    {
        path: "/merchant-management/authority/permission-mune",
        name: "权限配置",
        component: () => import("@/views/merchant-management/access-configuration/children/permission-mune/permission-mune.vue"),
        meta: {
            nameKey: "permissionMune",
        },
    },
    // {
    //   path: "/system-manage/auth/updata-role",
    //   name: "修改角色",
    //   component: () =>
    //     import(
    //       "@/views/sys-manage/access-configuration/children/role-info/role-info.vue"
    //     ),
    //   meta: {
    //     nameKey: "updataRoleInfo",
    //   },
    // },
    // {
    //   path: "/system-manage/auth/details-role",
    //   name: "角色详情",
    //   component: () =>
    //     import(
    //       "@/views/sys-manage/access-configuration/children/details-role-info/details-role-info.vue"
    //     ),
    //   meta: {
    //     nameKey: "detailsRoleInfo",
    //   },
    // },
    {
        path: "/merchant-management/user-manage",
        name: "用户管理",
        component: () => import("@/views/merchant-management/user-manage/user-manage.vue"),
    },
    {
        path: "/merchant-management/user-manage/add",
        name: "新增用户",
        component: () => import("@/views/merchant-management/user-manage/children/user-add/user-add.vue"),
    },
    {
        path: "/merchant-management/user-manage/up",
        name: "修改用户",
        component: () => import("@/views/merchant-management/user-manage/children/user-edit/user-edit.vue"),
    },
    {
        path: "/merchant-management/user-manage/operation-log",
        name: "操作日志",
        component: () => import("@/views/merchant-management/user-manage/children/operation-log/operation-log.vue"),
    },
    {
        path: "/merchant-management/authority/operation-log",
        name: "操作日志",
        component: () => import("@/views/merchant-management/access-configuration/children/operation-log/operation-log.vue"),
    },
    {
        path: "/oper-manage/invoice-info",
        name: "发票信息",
        component: () => import("@/views/oper-manage/invoice-info/invoice-info.vue"),
    },
    {
        path: "/oper-manage/invoice-info/details",
        name: "发票详情",
        component: () => import("@/views/oper-manage/invoice-info/chileren/invoice-details/invoice-details.vue"),
        meta: {
            nameKey: "invoiceDetails",
        },
    },
    {
        path: "/oper-manage/invoice-info/to-examine",
        name: "发票审核",
        component: () => import("@/views/oper-manage/invoice-info/chileren/invoice-audit/invoice-audit.vue"),
        meta: {
            nameKey: "invoiceAudit",
            footerBg: true,
        },
    },
    {
        path: "/oper-manage/order-manage/charge-order-list",
        name: "充电订单",
        component: () => import("@/views/oper-manage/order-manage/charge-order-list/charge-order-list.vue"),
    },
    {
        path: "/oper-manage/order-manage/charge-order-list/charge-order-detail",
        name: "订单详情",
        component: () => import("@/views/oper-manage/order-manage/charge-order-list/children/charge-order-detail/charge-order-detail.vue"),
        meta: {
            nameKey: "chargeOrderDetail",
        },
    },
    {
        path: "/oper-manage/order-manage/charge-order-list/abnormal-order",
        name: "充电异常处理",
        component: () => import("@/views/oper-manage/order-manage/charge-order-list/children/abnormal-order/abnormal-order.vue"),
        meta: {
            nameKey: "abnormalOrder",
        },
    },
    {
        path: "/oper-manage/order-manage/reserve-charging-order",
        name: "预约充电订单",
        component: () => import("@/views/oper-manage/order-manage/reserve-charging-order/reserve-charging-order.vue"),
    },
    {
        path: "/oper-manage/order-manage/reserve-charging-order/details",
        name: "预约充电订单详情",
        component: () => import("@/views/oper-manage/order-manage/reserve-charging-order/children/reserve-charging-order-detail/reserve-charging-order-detail.vue"),
        meta: {
            nameKey: "reserveChargingOrderDetails",
        },
    },
    {
        path: "/oper-manage/order-manage/off-card-order",
        name: "离线卡订单",
        component: () => import("@/views/oper-manage/order-manage/off-card-order-list/off-card-order-list.vue"),
    },
    {
        path: "/oper-manage/order-manage/off-card-order/charge-order-detail",
        name: "离线卡订单详情",
        component: () => import("@/views/oper-manage/order-manage/off-card-order-list/children/off-order-detail.vue"),
        meta: {
            nameKey: "offCardOrderDetails",
        },
    },
    {
        path: "/analysis-center/operate",
        name: "运营分析",
        component: () => import("@/views/analysis-center/operate/operate.vue"),
    },
    {
        path: "/analysis-center/revenue",
        name: "收入分析",
        component: () => import("@/views/analysis-center/revenue/revenue.vue"),
    },
];
// 把权限单独拿出来拼到路由里面去
const getPower = (list) => {
    const prwerObj = {};
    const config = configData.powerObj;
    list.map((item) => {
        if (config[item.privilegeCode]) {
            prwerObj[config[item.privilegeCode]] = item.checked;
        }
    });
    return prwerObj;
};
const routerObj = {};
const recursionRouter = (routerList, itemData) => {
    const userRouter = routerList.length == 0 ? mumeListData : routerList;
    const realRoutes = [];
    userRouter.forEach((v) => {
        if (v.children && v.children.length > 0) {
            const list = recursionRouter(v.children, v);
            list.forEach((li) => {
                realRoutes.push(li);
            });
        }
        else {
            allRouter.forEach((item) => {
                const ischildren = v.children && v.children.length > 0;
                if ((item.path != "" && item.path === v.url) ||
                    (item.path.indexOf(v.url) != -1 &&
                        item.path.length > v.url.length &&
                        !ischildren)) {
                    // console.log("??");
                    // 1 条件是路径相同   2 条件是当前路径是某个的子级(子级路由的定义是在父级路由后面添加，所有一定比父级长)
                    const data = JSON.parse(JSON.stringify(v));
                    let privilegeVoObj = {};
                    if (data.privilegeVoList && data.privilegeVoList.length > 0) {
                        privilegeVoObj = getPower(data.privilegeVoList);
                    }
                    // routerObj 记录已经添加过的路由， item.path.indexOf(v.url) != -1 添加子路由的时候有可能会添加多次
                    if (privilegeVoObj.query && !routerObj[item.path]) {
                        if (item.meta) {
                            item.meta.menuData = data;
                            item.meta.privilegeVoObj = privilegeVoObj;
                        }
                        else {
                            item.meta = {
                                privilegeVoObj: privilegeVoObj,
                                menuData: data,
                            };
                        }
                        if (itemData) {
                            item.meta.parentName = itemData.moduleName;
                        }
                        if (item.path === v.url) {
                            item.name = data.moduleName;
                            item.meta.mainPage = true;
                        }
                        realRoutes.push(item);
                        routerObj[item.path] = item.name;
                    }
                    // realRoutes.push(item);
                }
            });
        }
    });
    return realRoutes;
};
export default recursionRouter;
